module.exports = __webpack_public_path__ + "static/media/lobbyLandscape.fe01dcdd.jpg";